import { createApp } from 'vue'
import Antd from 'ant-design-vue';
import router from "./router/index"
import Notifications from '@kyvg/vue3-notification'
import VAR from "../modules/index"
import App from './App.vue'
import 'ant-design-vue/dist/reset.css';

import '@/assets/index.css'

const app = createApp(App);
app.use(router)
app.use(Notifications)
app.use(VAR)
app.use(Antd).mount('#app');